<script lang="ts">
  import { Icon } from '@/ui/base';

  let { onclick }: { onclick: () => void } = $props();
</script>

<button class="rounded-lg bg-tabs p-3 text-label-sm font-medium hocus:bg-tabs-H" {onclick}>
  <Icon icon="Add" aria-label="Neuer Tab" size={4} />
</button>
